import { render } from "./LearningTestResult.vue?vue&type=template&id=6f80d84e"
import script from "./LearningTestResult.vue?vue&type=script&lang=js"
export * from "./LearningTestResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__